import { render, staticRenderFns } from "./PlusMinus.vue?vue&type=template&id=70dc9773&scoped=true&"
import script from "./PlusMinus.vue?vue&type=script&lang=js&"
export * from "./PlusMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc9773",
  null
  
)

export default component.exports